import * as Sentry from "@sentry/react";
import { z } from "zod";

/**
 * Capture a custom error with Sentry
 */
export function captureError(error: Error, extras?: Record<string, any>) {
  Sentry.captureException(error, {
    extra: extras,
  });
}

/**
 * Send custom event to Sentry with automatic stack trace capture
 */
export function captureCustomEvent({
  message,
  debugData,
  level = "error",
}: {
  message: string;
  debugData?: Record<string, any>;
  level?: "info" | "warning" | "error" | "debug";
}) {
  const customError = new Error(message);
  customError.name = message;

  console.log("capture");
  Sentry.captureException(customError, {
    level,
    extra: debugData,
  });
}

export function safeParseSchemaWithSentry<T>(
  schema: z.ZodSchema<T>,
  data: any,
) {
  const result = schema.safeParse(data);
  if (!result.success) {
    captureCustomEvent({
      message: "Zod validation failed",
      debugData: {
        error: result.error,
        data: data,
      },
    });
  }
  return result;
}

/**
 * Set user information for Sentry
 */
export function setSentryUser(user_id: string, groups: string[]) {
  Sentry.setUser({ id: user_id, groups: groups });
}

/**
 * Clear user information from Sentry
 */
export function clearSentryUser() {
  Sentry.setUser(null);
}
